module.exports = __webpack_public_path__ + "static/media/115b633c-bd6f-4c55-9c4d-63594d3dc4f3-GXnbP2SxdcQLtQddjIv5tXxsfHgeXe.d59ff074.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/115b633c-bd6f-4c55-9c4d-63594d3dc4f3-GXnbP2SxdcQLtQddjIv5tXxsfHgeXe.webp
// module id = 619
// module chunks = 0